export default __webpack_public_path__ + "static/media/paint-bucket.1f12fd45.svg";